// extracted by mini-css-extract-plugin
export default {"linksContainerWrapper":"MobileFooter_linksContainerWrapper__GVbPT"};